import React from "react";
import { SideMenu, BackHeader } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import PenImg from "./../../../assets/images/pen.jpg";
import { styled } from "@mui/material/styles";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import Rating from "@mui/material/Rating";
import Stack from "@mui/material/Stack";
import ProfileImg from "./../../../assets/images/ProfileImage.png";
import { useNavigate } from "react-router-dom";
const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor:
      theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === "light" ? "#EBAF1E" : "#C4C4C4",
  },
}));

const PurchasesProductView = () => {
  const navigate = useNavigate();
  const [selectedPorductCounter, setSelectedPorductCounter] = React.useState(1);
  const detailDecrementHandler = () => {
    if (selectedPorductCounter > 1) {
      setSelectedPorductCounter(selectedPorductCounter - 1);
    }
  };
  return (
    <SideMenu purchseIcon={true}>
      <div className="page-details-container">
        <BackHeader backHanler={() => navigate(-1)} />
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
              <div className="purchase-product-card-container">
                <img src={PenImg} className="purchase-product-card-image" />
              </div>
            </Grid>
            <Grid item xl={8} lg={8} md={8} sm={12} xs={12}>
              <div>
                <p className="purchase-product-card-detail-heading">
                  Classmate Octane Colour Burst - Count of 10 (assorted)
                </p>
                <p className="purchase-product-card-description">
                  Integer consectetur scelerisque justo in tincidunt. Curabitur
                  orci lorem, dictum vel leo eget, congue lobortis orci. Donec
                  scelerisque enim ut sapien blandit suscipit.
                </p>
                <p className="purchase-product-card-details-price">$8.03</p>
                <dvi className="purchase-product-card-details-inc-dec-container">
                  <div className="purchase-product-card-inc-dec-main">
                    <button
                      className="purchase-product-card-inc-dec-button"
                      onClick={detailDecrementHandler}
                    >
                      -
                    </button>
                    <p className="purchase-product-card-selected-couonter">
                      {selectedPorductCounter}
                    </p>
                    <button
                      className="purchase-product-card-inc-dec-button"
                      onClick={() =>
                        setSelectedPorductCounter(selectedPorductCounter + 1)
                      }
                    >
                      +
                    </button>
                  </div>
                  <Button
                    className="purchase-product-card-add-button"
                    variant="text"
                  >
                    <p className="header-apply-button-text">ADD to cart</p>
                  </Button>
                </dvi>
              </div>
            </Grid>
          </Grid>
        </Box>
        <p className="purchase-product-card-details-heading">Description</p>
        <p className="purchase-product-card-description">
          Donec eget velit a purus aliquet finibus. Nam semper massa et metus
          bibendum, efficitur imperdiet tortor venenatis. Sed vitae purus nec
          nisl efficitur finibus vel sit amet urna. Sed volutpat leo eu massa
          facilisis, ut mattis purus imperdiet. Curabitur tincidunt ac ex ac
          vulputate. Aliquam at lacus et metus suscipit tincidunt.
        </p>
        <p className="purchase-product-card-details-heading">
          Additional Information
        </p>
        <table>
          <tr>
            <th className="purchase-product-card-details-table-heading">
              Manufacturer
            </th>
            <td className="purchase-product-card-details-table-description">
              Donec eget velit a purus aliquet finibus. Nam semper massa et
              metus bibendum, efficitur imperdiet tortor venenatis.
            </td>
          </tr>
          <tr>
            <th className="purchase-product-card-details-table-heading">
              Brand{" "}
            </th>
            <td className="purchase-product-card-details-table-description">
              Classmate
            </td>
          </tr>
          <tr>
            <th className="purchase-product-card-details-table-heading">
              Model Number
            </th>
            <td className="purchase-product-card-details-table-description">
              52346897
            </td>
          </tr>
          <tr>
            <th className="purchase-product-card-details-table-heading">
              Color
            </th>
            <td className="purchase-product-card-details-table-description">
              Multicoloured
            </td>
          </tr>
          <tr>
            <th className="purchase-product-card-details-table-heading">
              Material
            </th>
            <td className="purchase-product-card-details-table-description">
              plastic
            </td>
          </tr>
        </table>
        <p className="purchase-product-card-details-heading">Recommendations</p>
        <div className="purchase-product-recommendations-container">
          <div className="purchase-product-recommendations-rating-box-main">
            <p className="purchase-product-recommendations-rating">4.0</p>
            <div className="purchase-product-recommendations-rating-main">
              <Stack spacing={1}>
                <Rating
                  name="half-rating-read"
                  defaultValue={4}
                  precision={1}
                  readOnly
                />
              </Stack>
              <p className="purchase-product-recommendations-rating-all">
                (50)
              </p>
            </div>
          </div>
          <div className="purchase-product-recommendations-rating-progress-main">
            <div className="purchase-product-recommendations-rating-progress">
              <BorderLinearProgress variant="determinate" value={90} />
            </div>
            <div className="purchase-product-recommendations-rating-progress">
              <BorderLinearProgress variant="determinate" value={70} />
            </div>
            <div className="purchase-product-recommendations-rating-progress">
              <BorderLinearProgress variant="determinate" value={60} />
            </div>
            <div className="purchase-product-recommendations-rating-progress">
              <BorderLinearProgress variant="determinate" value={50} />
            </div>
            <div className="purchase-product-recommendations-rating-progress">
              <BorderLinearProgress variant="determinate" value={40} />
            </div>
          </div>
        </div>
        <br />
        <div className="box-rating-main">
          <div className="box-rating-header">
            <img src={ProfileImg} className="box-list-image" />

            <div className="box-rating-second-section">
              <div>
                <p className="box-rating-username">Johan smith</p>
                <p className="box-rating-time">5 Lectures, 45 min</p>
              </div>
              <div className="box-rating-show">
                <Stack spacing={1}>
                  <Rating
                    name="half-rating-read"
                    defaultValue={5}
                    precision={1}
                    readOnly
                  />
                </Stack>
                <p className="box-rating-day">Yesterday</p>
              </div>
            </div>
          </div>
          <p className="box-rating-message">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. In in lorem
            congue, euismod urna vitae, porttitor mi. Aliquam consectetur eu
            turpis ac congue.
          </p>
        </div>
        <div className="box-rating-main">
          <div className="box-rating-header">
            <img src={ProfileImg} className="box-list-image" />

            <div className="box-rating-second-section">
              <div>
                <p className="box-rating-username">Johan smith</p>
                <p className="box-rating-time">5 Lectures, 45 min</p>
              </div>
              <div className="box-rating-show">
                <Stack spacing={1}>
                  <Rating
                    name="half-rating-read"
                    defaultValue={5}
                    precision={1}
                    readOnly
                  />
                </Stack>
                <p className="box-rating-day">30 dec 2021</p>
              </div>
            </div>
          </div>
          <p className="box-rating-message">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. In in lorem
            congue, euismod urna vitae, porttitor mi. Aliquam consectetur eu
            turpis ac congue.
          </p>
        </div>
        <div className="box-rating-main">
          <div className="box-rating-header">
            <img src={ProfileImg} className="box-list-image" />

            <div className="box-rating-second-section">
              <div>
                <p className="box-rating-username">Johan smith</p>
                <p className="box-rating-time">5 Lectures, 45 min</p>
              </div>
              <div className="box-rating-show">
                <Stack spacing={1}>
                  <Rating
                    name="half-rating-read"
                    defaultValue={5}
                    precision={1}
                    readOnly
                  />
                </Stack>
                <p className="box-rating-day">30 dec 2021</p>
              </div>
            </div>
          </div>
          <p className="box-rating-message">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. In in lorem
            congue, euismod urna vitae, porttitor mi. Aliquam consectetur eu
            turpis ac congue.
          </p>
        </div>
      </div>
    </SideMenu>
  );
};
export default PurchasesProductView;
